import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopicOutcomesComponent } from './topic-outcomes.component';
import { PipesModule } from '../pipes/pipes.module';



@NgModule({
  declarations: [TopicOutcomesComponent],
  imports: [
    CommonModule, PipesModule
  ],
  exports:[TopicOutcomesComponent]
})
export class TopicOutcomesModule { }
